import { FinanceActions } from './finance.action';
import { InitializerAction } from '../initializer/initiliazer.action';
import { FinancePosition } from '../../models/pos-risk/finance-position';
import { ConsolidatedPosition } from '../../models/pos-risk/consolidated-position';
import { WithdrawHistory } from '../../models/finance/withdraw-history.model';
import { WithdrawExecutionDate } from '../../models/finance/withdraw-execution-date.model';

export class FinanceState {
    public errors: any;
    public finance: FinancePosition;
    public pending: boolean;
    public incomeDates: any;
    public extractDates: any [];
    public withdrawHistory: WithdrawHistory[];
    public withdrawExecutionDate: WithdrawExecutionDate;
    public brokeageNote: any;
    public pendingReport: boolean;
    public downloadSecundary: number;
    public pendingBrokageNote: number;
    public consolidatePosition: ConsolidatedPosition;
}

export const initialState: FinanceState = {
    errors: null,
    finance: new FinancePosition(),
    pending: false,
    incomeDates: null,
    extractDates: [],
    withdrawHistory: [],
    withdrawExecutionDate: null,
    brokeageNote: null,
    pendingReport: false,
    pendingBrokageNote: 0,
    downloadSecundary: null,
    consolidatePosition: new ConsolidatedPosition(),
};

export function FinanceReducer(state: FinanceState = initialState, action: any): FinanceState {

    switch (action.type) {

        case FinanceActions.getFinancePosition:
            return { ...state, ...{ finance: state.finance, errors: null, pending: true, ...action.payload } };

        case FinanceActions.getFinancePositionError:
            return { ...state, ...{ errors: action.payload, pending: false } };

        case FinanceActions.getFinancePositionSuccess:
            return { ...state, ...{ finance: { ...state.finance, ...action.payload }, pending: false, errors: null } };

        case FinanceActions.getNoteIncomeDate:
            return { ...state, ...{ pending: true, errors: null } };
        case FinanceActions.getNoteIncomeDateSuccess:
            return { ...state, ...{ pending: false, errors: null, incomeDates: action.payload } };
        case FinanceActions.getNoteIncomeDateError:
            return { ...state, ...{ pending: false, errors: action.payload } };

        case FinanceActions.getBrokageNoteIncome:
            return { ...state, ...{ pendingBrokageNote: +state.pendingBrokageNote + 1, errors: null } };
        case FinanceActions.getBrokageNoteIncomeSuccess:
            return { ...state, ...{ pendingBrokageNote: +state.pendingBrokageNote - 1, errors: null, brokeageNote: action.payload } };
        case FinanceActions.getBrokageNoteIncomeError:
            return { ...state, ...{ pendingBrokageNote: +state.pendingBrokageNote - 1, errors: action.payload } };

        case FinanceActions.getExtractDates:
            return { ...state, ...{ pending: true, errors: null } };
        case FinanceActions.getExtractDatesSuccess:
            return { ...state, ...{ pending: false, errors: null, extractDates: [...action.payload] } };
        case FinanceActions.getExtractDatesError:
            return { ...state, ...{ pending: false, errors: action.payload } };

        case FinanceActions.getExtractPDF:
            return { ...state, ...{ pending: true, errors: null } };
        case FinanceActions.getExtractPDFSuccess:
            return { ...state, ...{ pending: false, errors: null } };
        case FinanceActions.getExtractPDFError:
            return { ...state, ...{ pending: false, errors: action.payload } };

        case FinanceActions.getIncomeTaxPDF:
            return { ...state, ...{ pendingReport: true, errors: null, downloadSecundary: action.payload.type } };
        case FinanceActions.getIncomeTaxPDFSuccess:
            return { ...state, ...{ pendingReport: false, errors: null, downloadSecundary: null } };
        case FinanceActions.getIncomeTaxPDFError:
            return { ...state, ...{ pendingReport: false, errors: action.payload, downloadSecundary: null } };

        case FinanceActions.getReport:
            return { ...state, ...{ pendingReport: true, errors: null, downloadSecundary: action.payload.type } };
        case FinanceActions.getReportSuccess:
            return { ...state, ...{ pendingReport: false, errors: null, downloadSecundary: null } };
        case FinanceActions.getReportError:
            return { ...state, ...{ pendingReport: false, errors: action.payload, downloadSecundary: null} };

        case FinanceActions.getReportByType:
            return { ...state, ...{ pendingReport: true, errors: null, downloadSecundary: action.payload.type } };
        case FinanceActions.getReportByTypeSuccess:
            return { ...state, ...{ pendingReport: false, errors: null, downloadSecundary: null } };
        case FinanceActions.getReportByTypeError:
            return { ...state, ...{ pendingReport: false, errors: action.payload, downloadSecundary: null} };

        case FinanceActions.getRealtimeConsolidatedPosition:
            return { ...state, ...{ pending: true, errors: null } };
        case FinanceActions.getRealtimeConsolidatedPositionSuccess:
            return { ...state, ...{ pending: false, errors: null, consolidatePosition: action.payload } };
        case FinanceActions.getRealtimeConsolidatedPositionError:
            return { ...state, ...{ pending: false, errors: action.payload } };

        case FinanceActions.getRealtimeFinancePosition:
            return { ...state, ...{ pending: true, errors: null } };
        case FinanceActions.getRealtimeFinancePositionSuccess:
            return { ...state, ...{ pending: false, errors: null, finance: action.payload } };
        case FinanceActions.getRealtimeFinancePositionError:
            return { ...state, ...{ pending: false, errors: action.payload } };

        case FinanceActions.getConsolidatePosition:
            return { ...state, ...{ pending: true, errors: null } };
        case FinanceActions.getConsolidatePositionSuccess:
            const pending = action.payload.stockPendingOperations +  action.payload.stockDTPendingOperations +
            action.payload.futurePendingOperations +  action.payload.futureDTPendingOperations +
            action.payload.optionsPendingOperations;

            return {...state, ...{ pending: false, errors: null,
                consolidatePosition: { ...action.payload, ...{ pendingStockOperationsTotal: pending} }}};

        case FinanceActions.getConsolidatePositionError:
            return { ...state, ...{ pending: false, errors: action.payload } };

        case FinanceActions.getWithdrawHistory:
            return { ...state, ...{ pending: true, errors: null } };
        case FinanceActions.getWithdrawHistorySuccess:
            return { ...state, ...{ pending: false, errors: null, withdrawHistory: [...action.payload] } };
        case FinanceActions.getWithdrawHistoryError:
            return { ...state, ...{ pending: false, errors: action.payload } };

        case FinanceActions.getTransferExecutionDate:
            return { ...state, ...{ pending: true, errors: null } };
        case FinanceActions.getTransferExecutionDateSuccess:
            return { ...state, ...{ pending: false, errors: null, withdrawExecutionDate: action.payload } };
        case FinanceActions.getTransferExecutionDateError:
            return { ...state, ...{ pending: false, errors: action.payload } };

        case InitializerAction.resetUserRelatedData:
            // return {...state, ...{finance: initialState.finance, consolidatePosition: initialState.consolidatePosition }};
            return initialState;

        default:
            return state;
    }
}
